import React, { FunctionComponent, useEffect, useState } from 'react'
import styles from './ConfigPage.module.sass'
import { useRootDispatch, useRootSelector } from '../../../../utils/hooks'
import { configActions, ConfigEditState } from '../../../../redux/pages/settings/config'
import { Table } from '../../../data-components/Table/Table/Table'
import { Column } from '../../../data-components/Table/Column'
import { Config } from '../../../../responses/refs/refs'
import Button from '../../../controls/Button/Button'
import refStyles from '../RefPage/RefPage.module.sass'
import { Dialog } from '../../../etc/Dialog/Dialog'
import OkCancel from '../../../controls/OkCancel/OkCancel'
import Label, { Display } from '../../../controls/Label/Label'
import Field from '../../../controls/Field/Field'
import { pick } from '../../../../utils/utils'
import Helmet from 'react-helmet'
import EditIcon from '../../../../../files/edit.svg'

const ConfigPage: FunctionComponent = () => {
    const dispatch = useRootDispatch()
    const { data, editState } = useRootSelector(state => pick(state.pages.settings.config, 'data', 'editState'))
    const [value, setValue] = useState('')

    useEffect(() => {
        dispatch(configActions.list.request())
    }, [dispatch])

    useEffect(() => {
        ConfigEditState.is.update(editState) && setValue(editState.payload.value)
    }, [editState])

    return <div className={styles.config}>
        <Helmet><title>Конфигурация</title></Helmet>
        <Table className={refStyles.table} data={data}>
            <Column<Config>
                headerRenderer={'Название поля'}
                cellRenderer={config => config.name}
            />
            <Column<Config>
                headerRenderer={'Значение'}
                cellRenderer={config => config.value}
            />
            <Column<Config>
                cellRenderer={config => <Button
                    className={refStyles.actions}
                    title={'Редактировать'}
                    onClick={() => dispatch(configActions.startEdit(config))}
                >
                    <EditIcon/>
                </Button>}
            />
        </Table>
        {
            ConfigEditState.is.update(editState) && <Dialog
                onClose={() => dispatch(configActions.cancelEdit())}
                actions={({ onClose }) => <OkCancel
                    onCancel={onClose}
                    onOk={() => dispatch(configActions.update.request({
                        ...editState.payload,
                        value,
                    }))}
                />}
                header={'Редактирование поля'}
                subheader={editState.payload.name}
            >
                <Label className={styles.label} display={Display.TOP} label={'Значение'}>
                    <Field
                        block
                        type={'text'}
                        value={value}
                        onChange={setValue}
                    />
                </Label>
            </Dialog>
        }
    </div>
}

export default ConfigPage